import { render } from "./VariantDetails.vue?vue&type=template&id=38f1d8c5"
import script from "./VariantDetails.vue?vue&type=script&lang=js"
export * from "./VariantDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__